import React from 'react';

interface HowToPlayModalProps {
  open: boolean;
  onClose: () => void;
}

const HowToPlayModal: React.FC<HowToPlayModalProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, maxWidth: 420, boxShadow: '0 2px 16px rgba(0,0,0,0.15)', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <p style={{ margin: 0, fontSize: 45, lineHeight: '100%', fontFamily:'Monigue, Arial, sans-serif' }}>How to play Matchset</p>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{ background: 'none', border: 'none', padding: 0, marginLeft: 16, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="#1C1C1E"/>
            </svg>
          </button>
        </div>
        <div style={{ textAlign: 'left'}}>
          <p>Arrange the 16 icon tiles into 4 rows of 4. Drag them, or tap a tile and then tap where it should go.</p>
          <br/>
          <p>To win, each row must contain icon tiles to create a set that matches a common theme.</p>
          {/* Example of a filled but not submitted row */}
          <div
            style={{
              display: 'flex',
              gap: 12,
              border: '1px solid #DFE4E9',
              padding: '10px 15px',
              borderRadius: 200,
              background: '#fff',
              margin: '16px 0',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            { [
              { src: "/icons/plant-fill.svg", alt: "plant" },
              { src: "/icons/potted-plant-fill.svg", alt: "potted plant" },
              { src: "/icons/tree-fill.svg", alt: "tree" },
              { src: "/icons/tree-palm-fill.svg", alt: "palm tree" }
            ].map((icon, i) => (
              <span
                key={i}
                style={{
                  width: '100%',
                  minHeight: 55,
                  maxHeight: 55,
                  height: 55,
                  padding: 0,
                  borderRadius: 200,
                  background: '#9B5DE5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  userSelect: 'none',
                  pointerEvents: 'none',
                }}
              >
                <img
                  src={icon.src}
                  alt={icon.alt}
                  style={{ width: 20, height: 20, filter: 'brightness(0) invert(1)' }}
                  draggable={false}
                />
              </span>
            )) }
          </div>
          <p>When a row contains icon tiles that all match the same theme, it will lock in and change colour.</p>
          {/* Example of a locked in correct row */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              background: '#9B5DE5',
              border: '1px solid #9B5DE5',
              borderRadius: 200,
              padding: '10px 15px',
              margin: '16px 0',
              minHeight: 55,
              color: '#fff',
            }}
          >
            <span
              style={{
                fontWeight: 600,
                fontSize: 20,
                color: '#fff',
                fontFamily: 'inherit',
                marginRight: 10,
                whiteSpace: 'nowrap',
                minWidth: 120,
                textAlign: 'right',
              }}
            >
              Plants
            </span>
            <div style={{ display: 'flex', gap: 10, flex: 1, alignItems: 'center' }}>
              {[
                { src: "/icons/plant-fill.svg", alt: "plant" },
                { src: "/icons/potted-plant-fill.svg", alt: "potted plant" },
                { src: "/icons/tree-fill.svg", alt: "tree" },
                { src: "/icons/tree-palm-fill.svg", alt: "palm tree" }
              ].map((icon, i) => (
                <span
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '17px 0',
                    flex: 1,
                  }}
                >
                  <img
                    src={icon.src}
                    alt={icon.alt}
                    style={{ width: 20, height: 20, filter: 'brightness(0) invert(1)' }}
                    draggable={false}
                  />
                </span>
              ))}
            </div>
          </div>
          <p>You have 4 hearts to try and find all the matches.</p>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal;
